/**
 * Multi-filter staging for the mobile filter drawer.
 *
 * Dawn's FacetFiltersForm (assets/facets.js) auto-submits on every `input`
 * event via a debounced handler, which means every checkbox toggle or sort
 * change triggers a fetch + DOM re-render. For the mobile drawer we want
 * the opposite: the user stages several selections across multiple filters,
 * then commits them all at once by tapping Apply.
 *
 * Approach:
 *   1. Capture-phase listener on the mobile form intercepts `input` events
 *      before Dawn's bubble-phase listener runs, calling
 *      stopImmediatePropagation() so Dawn never sees them. The native
 *      checkbox/select toggle still happens (that's the browser, not JS),
 *      so the UI state updates immediately.
 *   2. Capture-phase click listener delegated on the form handles the two
 *      kinds of Apply buttons:
 *        - Global Apply (inside #FacetsWrapperMobile's direct footer):
 *          trigger the actual form submission via FacetFiltersForm.renderPage,
 *          then let Dawn's inline onclick close the drawer as before.
 *        - Per-filter Apply (inside a submenu's footer): treat as "done
 *          with this filter", close only the submenu, block Dawn's inline
 *          onclick that would otherwise close the whole drawer.
 *
 * Delegation on the form survives DOM replacement when Dawn re-renders the
 * facets after Apply is tapped.
 *
 * Desktop filter behavior is untouched — this script only binds to
 * #FacetFiltersFormMobile.
 */

(() => {
  'use strict';

  const FORM_ID = 'FacetFiltersFormMobile';
  const WRAPPER_ID = 'FacetsWrapperMobile';

  const init = () => {
    const form = document.getElementById(FORM_ID);
    if (!form) return;

    form.addEventListener('input', blockAutoSubmit, true);
    form.addEventListener('click', handleClick, true);
  };

  const blockAutoSubmit = (event) => {
    event.stopImmediatePropagation();
  };

  const handleClick = (event) => {
    const button = event.target.closest('button[type="button"]');
    if (!button) return;

    const footer = button.closest('.mobile-facets__footer');
    if (!footer) return;

    const parent = footer.parentElement;
    const isGlobalApply = parent && parent.id === WRAPPER_ID;

    if (isGlobalApply) {
      submitForm(document.getElementById(FORM_ID));
      return;
    }

    event.stopImmediatePropagation();
    event.preventDefault();
    const details = button.closest('.mobile-facets__details');
    if (details) details.open = false;
  };

  const submitForm = (form) => {
    if (!form || typeof FacetFiltersForm === 'undefined' || !FacetFiltersForm.renderPage) return;
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
